import React from 'react'
import { NavLink } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import { withTranslation } from 'react-i18next'
import { Drawer, List, ListItem, ListItemIcon, ListItemText } from '@material-ui/core'

import SmsIcon from '@material-ui/icons/Sms'
import GroupIcon from '@material-ui/icons/Group'
import StarsIcon from '@material-ui/icons/Stars';

const SideMenu = ({ t, open, onClose }) => {
    const classes = useStyles()

    const MENU_ITEMS = [
        {
            title: t('message_managament'),
            path: '/',
            Icon: SmsIcon
        },
        {
            title: t('rating'),
            path: '/ticket-rates',
            Icon: StarsIcon
        },
        {
            title: t('user_managament'),
            path: '/users',
            Icon: GroupIcon
        }
    ]

    return (
        <Drawer anchor={'left'} open={open} onClose={onClose} className={classes.drawer} classes={{ paper: classes.drawerPaper }}>
            <List>
                {MENU_ITEMS.map((item, index) => (
                    <ListItem button key={item.path} component={NavLink} to={item.path} color="inherit"   >
                        <ListItemIcon><item.Icon color="inherit" /></ListItemIcon>
                        <ListItemText primary={item.title} />
                    </ListItem>
                ))}
            </List>
        </Drawer>
    )
}

const drawerWidth = 260

const useStyles = makeStyles((theme) => ({
    drawer: {
        width: drawerWidth,
        flexShrink: 0,

    },
    drawerPaper: {
        width: drawerWidth,
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white
    },
    drawerContainer: {
        overflow: 'auto',
    },
}));

export default withTranslation()(SideMenu)

